module.exports = __webpack_public_path__ + "static/media/star_icon.46da3b5c.svg";